import { useCallback } from "react";
import { graphql, useMutation } from "react-relay";
import * as Haptic from "expo-haptics";
import { useSetFocusMutation } from "./__generated__/useSetFocusMutation.graphql";
import { Platform } from "react-native";

const MUTATION = graphql`
  mutation useSetFocusMutation(
    $storecastId: ID!
    $subject: StorecastFocusSubjectNewInput!
  ) {
    dashboard(dashboardId: $storecastId) {
      setNewFocus(subject: $subject) {
        subject {
          nodeId
          detailItemId
        }
      }
    }
  }
`;
export function useSetWidgetFocus(widgetId: string, storecastId?: string) {
  const [mutation] = useMutation<useSetFocusMutation>(MUTATION);

  const setSingleWidgetFocus = useCallback(
    (detailItemId?: string) => {
      if (!storecastId) {
        return;
      }
      if (Platform.OS === "ios") {
        Haptic.impactAsync(Haptic.ImpactFeedbackStyle.Medium);
      }
      mutation({
        onError: (error) => {
          console.log(error);
        },
        optimisticUpdater: (store) => {
          const storecast = store.get(storecastId);
          if (!storecast) return;
          storecast.setValue(widgetId, "focusedNodeId");
          storecast.setValue(detailItemId, "focusedDetailItemId");
        },
        updater: (store) => {
          const storecast = store.get(storecastId);
          if (!storecast) return;
          storecast.setValue(widgetId, "focusedNodeId");
          storecast.setValue(detailItemId, "focusedDetailItemId");
        },
        variables: {
          storecastId,
          subject: {
            nodeId: widgetId,
            detailItemId,
          },
        },
      });
    },
    [mutation, storecastId, widgetId]
  );

  return setSingleWidgetFocus;
}
